import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox } from 'semantic-ui-react'
import Dialog from '~/components/Dialog'

interface Props {
  isOpen: boolean
  handleClose: () => void
  handleSubmit: (printBusinessPaper: number) => void
}

const GeneratePdfs:React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { isOpen, handleClose, handleSubmit } = props

  const [printBusinessPaper, setPrintBusinessPaper] = useState(0)

  useEffect(() => {
    if(isOpen) {
      setPrintBusinessPaper(0)
    }
  }, [isOpen])

  function renderCheckMga() {
    return <Checkbox
      label={t('Print on business paper?')}
      checked={printBusinessPaper === 1}
      onChange={(_, data) => setPrintBusinessPaper(data.checked ? 1 : 0)}
    />
  }

  return <Dialog
    textHeader={t('Create MGA PDF')}
    isDialogOpen={isOpen}
    textClose={t('Close')}
    handleClose={() => handleClose()}
    textSubmit={t('Create MGA PDF')}
    handleSubmit={() => handleSubmit(printBusinessPaper)}
    textContent={renderCheckMga()}
    type='abort'
  />
}
export default GeneratePdfs